import { enableProdMode, enableProfiling } from '@angular/core';

import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { bootstrapApplication } from '@angular/platform-browser';

if (environment.production) {
  enableProdMode();
}

enableProfiling();

try {
  await bootstrapApplication(AppComponent, appConfig);
} catch (error) {
  console.error(error);
}
